import { useQuery } from "@apollo/client";
import {
    PricingSchemeApplyListResponse,
    GET_PRICING_SCHEME_APPLY_LISTING
} from "../../graphql/queries/getPricingSchemeApplyList";
import { useEffect, useState } from "react";
import { PricingSchemeApplyFilterType, PricingSchemeApplyType } from "../../graphql/types/PricingSchemeApplyType";

export interface DspPricingSchemeApplyQueryResult {
    pricingSchemeApplyData: PricingSchemeApplyType[];
    loading: boolean;
    refetch: (variables?: any) => Promise<any>;
    totalElements: number;
    buildQueryVariables: () => any;
}

export const useDspPricingSchemeApplyQuery = (
    filters: PricingSchemeApplyFilterType,
    businessScenario: number | null,
    currentPage: number,
    pageSize: number
): DspPricingSchemeApplyQueryResult => {
    const [pricingSchemeApplyData, setPricingSchemeApplyData] = useState<PricingSchemeApplyType[]>([]);
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState(0);

    const buildQueryVariables = () => {
        const formatTimeWithFullDay = (timeRange: [string | null, string | null] | null | undefined) => {
            if (!timeRange) return undefined;

            const start = timeRange[0] ? `${timeRange[0]} 00:00:00` : null;
            const end = timeRange[1] ? `${timeRange[1]} 23:59:59` : null;
            if (!start && !end) return undefined;
            return { start, end };
        };

        const timeRanges = {
            pricingSchemeId: filters.pricingSchemeId,
            bindTime: formatTimeWithFullDay(filters.bindTime),
            effectiveTime: formatTimeWithFullDay(filters.effectiveTime),
            activeStatus: filters.activeStatus,
            operatorId: filters.operatorId,
            timezone: filters.timezone,
            bindValue: filters.bindValue,
            businessScenario: businessScenario
        };
        const { tab, ...filtersWithoutTab } = filters;
        const queryFilters = {
            ...filtersWithoutTab,
            ...timeRanges
        };

        return {
            filters: queryFilters,
            pageRequest: {
                page: currentPage,
                size: pageSize,
                sortBy: "id",
                sortDirection: "DESC"
            }
        };
    };

    const { data, loading: queryLoading, refetch } = useQuery<PricingSchemeApplyListResponse>(
        GET_PRICING_SCHEME_APPLY_LISTING,
        { variables: buildQueryVariables() }
    );

    useEffect(() => {
        const responseData = data?.getPricingSchemeApplyPageable?.content;
        if (responseData) {
            setPricingSchemeApplyData(responseData);
            setLoading(false);
        }
        const totalElements = data?.getPricingSchemeApplyPageable?.totalElements;
        if (totalElements) {
            setTotal(totalElements);
        }
    }, [data]);

    return {
        pricingSchemeApplyData,
        loading: loading || queryLoading,
        refetch,
        totalElements: total,
        buildQueryVariables
    };
};
